import { __decorate } from "tslib";
import lang from '@blade-sxp/portrait-management/lang/index';
import ImportModuleChunk from '@blade-sxp/portrait-management/pages/components/import-module-chunk.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { addPortraitLib, getPortraitLibAll } from '@blade-sxp/portrait-management/api/porttaitLib';
import { addVehicleLib, getVehicleLibAll } from '@blade-sxp/portrait-management/api/vehicleLib';
import { LibStatusEnum, LibraryTypeEnum } from '@blade-sxp/portrait-management/interfaces/common';
let default_1 = class default_1 extends Vue {
    libType;
    PORTRAIT_LIBRARY = LibraryTypeEnum.PORTRAIT_LIBRARY;
    AUTO_FEATURE = LibraryTypeEnum.AUTO_FEATURE;
    inputMaxLength = 50;
    fileArr = [];
    libraryAry = [];
    uploadSuccseArr = [];
    // 弹窗相关
    visible = false;
    bigFileMd5 = '';
    formData = {
        resource: 'existedLibrary',
        selectLibId: '',
        libName: '',
    };
    selectLoading = false;
    get getBtnState() {
        if (this.formData.resource === 'existedLibrary' && this.formData.selectLibId) {
            return false;
        }
        if (this.formData.resource === 'newLibrary' && this.formData.libName) {
            return false;
        }
        return true;
    }
    get inputHolder() {
        if (this.libType === this.PORTRAIT_LIBRARY)
            return this.$t('portraitLibraryNameInputHolder');
        return this.$t('vehicleLibraryNameInputHolder');
    }
    created() {
        this.$router.onReady(async () => {
            const query = this.$route.query;
            await this.getLibAll();
            this.formData.selectLibId = query.libId.toString();
        });
    }
    // 获取待选项
    async getLibAll() {
        if (this.selectLoading)
            return;
        this.selectLoading = true;
        try {
            switch (this.libType) {
                case this.PORTRAIT_LIBRARY:
                    let portraitLibAllRes = await getPortraitLibAll({
                        status: [LibStatusEnum.DISABLE, LibStatusEnum.ENABLE],
                    });
                    this.libraryAry = portraitLibAllRes.map((lib) => {
                        return {
                            libId: lib.libId.toString(),
                            libraryName: lib.libraryName ?? '-',
                        };
                    });
                    break;
                case this.AUTO_FEATURE:
                    let vehicleLibAllRes = await getVehicleLibAll('AUTO_MOBILE', [LibStatusEnum.DISABLE, LibStatusEnum.ENABLE]);
                    this.libraryAry = vehicleLibAllRes.map((lib) => {
                        return {
                            libId: lib.libId.toString(),
                            libraryName: lib.name,
                        };
                    });
                    break;
            }
        }
        catch (error) {
            console.log('接口错误', error);
        }
        this.selectLoading = false;
    }
    async handleUploadFile() {
        try {
            let libId = '';
            let isEdit = this.formData.resource === 'existedLibrary';
            let selectLibId = this.formData.selectLibId;
            let inputLibName = this.formData.libName;
            switch (this.libType) {
                case this.PORTRAIT_LIBRARY:
                    libId = isEdit ? selectLibId : (await addPortraitLib({ name: inputLibName })).libId.toString();
                    break;
                case this.AUTO_FEATURE:
                    libId = isEdit ? selectLibId : (await addVehicleLib({ name: inputLibName })).libId.toString();
                    break;
            }
            this.$refs.importModuleChunk.setLibraryid(libId);
            this.$nextTick(() => {
                this.$refs.importModuleChunk.onFileUpload();
            });
        }
        catch (error) {
            console.log('接口报错');
        }
    }
    onUploadSuccess() {
        this.$emit('upload-success');
    }
};
__decorate([
    Prop({ default: LibraryTypeEnum.PORTRAIT_LIBRARY })
], default_1.prototype, "libType", void 0);
default_1 = __decorate([
    Component({
        components: { ImportModuleChunk },
        i18n: {
            messages: {
                en: {
                    importTo: 'Import to',
                    existedLibrary: 'Existed Library',
                    libraryNameHolder1: 'Please Select library',
                    libraryNameHolder2: 'please enter',
                    uploadZipFile: 'Upload Zip File',
                    uploadFailedSize: 'File size: up to 20m',
                    uploadSuccse: 'upload Complete',
                    upload: 'Upload',
                    ...lang.en,
                },
                zh: {
                    importTo: '导入',
                    existedLibrary: '现有库',
                    libraryNameHolder1: '请选择库',
                    libraryNameHolder2: '请输入',
                    uploadZipFile: '上传 Zip 文件',
                    uploadFailedSize: '文件大小最多20m',
                    uploadSuccse: '上传成功',
                    upload: '上传',
                    ...lang.zh,
                },
            },
        },
    })
], default_1);
export default default_1;
